// ----------------------------------------------------------------------------
// Quantity Selector Extension (Simplified Product & Variant Limits)
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Functionality
// -------------------------------------

var validationRules = {
  product_quantity_max: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant, _itemData$product;
      // Return null if a variant-specific limit exists
      if (itemData !== null && itemData !== void 0 && (_itemData$variant = itemData.variant) !== null && _itemData$variant !== void 0 && (_itemData$variant = _itemData$variant.custom) !== null && _itemData$variant !== void 0 && (_itemData$variant = _itemData$variant.max_quantity) !== null && _itemData$variant !== void 0 && _itemData$variant.value) return null;

      // Otherwise, return the product-level limit
      return ((_itemData$product = itemData.product) === null || _itemData$product === void 0 || (_itemData$product = _itemData$product.custom) === null || _itemData$product === void 0 || (_itemData$product = _itemData$product.max_quantity) === null || _itemData$product === void 0 ? void 0 : _itemData$product.value) || null;
    },
    condition_callback: (current_quantity, max_quantity) => current_quantity <= max_quantity,
    error_message: (current_quantity, max_quantity, itemData) => translate('You can only add up to {{ MAX_QUANTITY }} of this product.', 'quantity.error.limit_max_product', {
      QUANTITY: current_quantity,
      MAX_QUANTITY: max_quantity,
      itemData
    })
  },
  variant_quantity_max: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant2;
      return parseInt((_itemData$variant2 = itemData.variant) === null || _itemData$variant2 === void 0 || (_itemData$variant2 = _itemData$variant2.custom) === null || _itemData$variant2 === void 0 || (_itemData$variant2 = _itemData$variant2.max_quantity) === null || _itemData$variant2 === void 0 ? void 0 : _itemData$variant2.value, 10) || null;
    },
    condition_callback: (current_quantity, max_quantity) => current_quantity <= max_quantity,
    error_message: (current_quantity, max_quantity, itemData) => translate('You can only add up to {{ MAX_QUANTITY }} of the selected variant.', 'quantity.error.limit_max_variant', {
      QUANTITY: current_quantity,
      MAX_QUANTITY: max_quantity,
      itemData
    })
  },
  product_quantity_min: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant3, _itemData$product2;
      // Return null if a variant-specific limit exists
      if (itemData !== null && itemData !== void 0 && (_itemData$variant3 = itemData.variant) !== null && _itemData$variant3 !== void 0 && (_itemData$variant3 = _itemData$variant3.custom) !== null && _itemData$variant3 !== void 0 && (_itemData$variant3 = _itemData$variant3.min_quantity) !== null && _itemData$variant3 !== void 0 && _itemData$variant3.value) return null;

      // Otherwise, return the product-level limit
      return ((_itemData$product2 = itemData.product) === null || _itemData$product2 === void 0 || (_itemData$product2 = _itemData$product2.custom) === null || _itemData$product2 === void 0 || (_itemData$product2 = _itemData$product2.min_quantity) === null || _itemData$product2 === void 0 ? void 0 : _itemData$product2.value) || null;
    },
    condition_callback: (current_quantity, min_quantity) => current_quantity >= min_quantity,
    error_message: (current_quantity, min_quantity, itemData) => translate('You must add at least {{ MIN_QUANTITY }} of this product.', 'quantity.error.limit_min_product', {
      QUANTITY: current_quantity,
      MIN_QUANTITY: min_quantity,
      itemData
    })
  },
  variant_quantity_min: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant4;
      return parseInt((_itemData$variant4 = itemData.variant) === null || _itemData$variant4 === void 0 || (_itemData$variant4 = _itemData$variant4.custom) === null || _itemData$variant4 === void 0 || (_itemData$variant4 = _itemData$variant4.min_quantity) === null || _itemData$variant4 === void 0 ? void 0 : _itemData$variant4.value, 10) || null;
    },
    condition_callback: (current_quantity, min_quantity) => current_quantity >= min_quantity,
    error_message: (current_quantity, min_quantity, itemData) => translate('You must add at least {{ MIN_QUANTITY }} of the selected variant.', 'quantity.error.limit_min_variant', {
      QUANTITY: current_quantity,
      MIN_QUANTITY: min_quantity,
      itemData
    })
  }
};
iamotaEventHandler.subscribe('iamForm:quantity:validation:init', _ref => {
  var {
    iamFormElement,
    validator
  } = _ref;
  var quantityInput = iamFormElement;
  var _loop = function _loop(ruleType) {
    var rule = validationRules[ruleType];
    validator.addField(quantityInput.control, [{
      validator: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        var result = condition_value === null || rule.condition_callback(parseInt(current_quantity, 10), condition_value, itemData);
        Debug.extreme("Validating Quantity [".concat(ruleType, "]: ").concat(current_quantity, " vs. ").concat(condition_value, " => ").concat(result ? Debug.colors.bgGreen('Valid') : Debug.colors.bgRed('Invalid')), {
          current_quantity,
          condition_value,
          result,
          itemData,
          fields
        });
        return result;
      },
      errorMessage: (current_quantity, _fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        return rule.error_message(current_quantity, condition_value, itemData);
      }
    }], {
      errorsContainer: quantityInput.errorContainer
    });
  };
  for (var ruleType in validationRules) {
    _loop(ruleType);
  }
}, {
  source: "quantity-input--metafield-limits.js"
});